import React, { Component } from 'react';
import { Modal, Spin, Button } from 'antd';
import TableC from '../../../basicElement/TableC';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

const CONSTANTS = {
    title: '报价单版本',
};

class Versions extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    loadData = () => {
        // const { record: { jdeMainApplyId } } = this.state;
        // this.setState({ loading: true });
        // Fetch.post(API_URL.contract.queryJdeMainApplyApprovalHistory, {
        //     jdeMainApplyId,
        // }).then(res => {
        //     this.setState({
        //         data: res.data,
        //         loading: false,
        //     }, () => {
        //         this.loadData();
        //     });
        // }).catch(error => {
        //     console.error(error);
        //     this.setState({ loading: false });
        // });
        this.setState({ data: [
            {version: 'V2', baName: '王倩茹', submitVersion: 'V2', conclusion: 'BDM审批通过', date: '2020-09-16 09:00:00'},
            {version: 'V1', baName: '王倩茹', submitVersion: 'V1', conclusion: 'BDM审批不通过', disagreeReason: '合理性调整', date: '2020-09-16 09:00:00'}
        ] });
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getColumns = () => ([
        {
            title: '报价单版本',
            dataIndex: 'version',
            key: 'version',
            width: 80,
        }, {
            title: 'BA',
            dataIndex: 'baName',
            key: 'baName',
            width: 80,
        }, {
            title: 'BA提交次数',
            dataIndex: 'submitVersion',
            key: 'submitVersion',
            width: 85,
        }, {
            title: '合理性审批结论',
            dataIndex: 'conclusion',
            key: 'conclusion',
            width: 120,
        },  {
            title: '审批不通过原因',
            dataIndex: 'disagreeReason',
            key: 'disagreeReason',
        },  {
            title: '提交时间',
            dataIndex: 'date',
            key: 'date',
            width: 85,
        }
    ])

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => ({ ...item } ));
        return dataSource;
    }

    render() {
        const { visible, loading, record } = this.state;
        const { quotationNum, salesforceId } = record;
        return (
            <Modal
                title={CONSTANTS.title}
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="640px"
                bodyStyle={{ maxHeight: 500 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <div style={{ marginBottom: 16 }}>
                        报价单号：{quotationNum}
                        <span className="ant-divider" />
                        Salesforce ID：{salesforceId}
                    </div>
                    <TableC
                        loading={loading}
                        data={this.getDataSource()}
                        columns={this.getColumns()}
                        className="quotationVersion"
                    />
                </div>
            </Modal>
        );
    }
}

export default Versions;


// WEBPACK FOOTER //
// ./src/components/quotation/list/Components/Versions.js